import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = "/web/powerbank";

// GET all power banks
function getAllPowerBanks(status?: string, keyword?: string) {
  const params: any = {};
  if (status) params.status = status;
  if (keyword) params.keyword = keyword;

  return api.get(`${baseUrl}`, params);
}

// ADD power bank
function addPowerBankAPI(payload: {
  box_id: number;
  unique_id: string;
  status: string;
  battery_level: number;
  health_status: string;
  slot_number: number | string;
}) {
  return api.create(`${baseUrl}`, payload);
}

// UPDATE power bank
function updatePowerBankAPI(
  id: string,
  payload: {
    box_id: number;
    unique_id: string;
    status: string;
    battery_level: number;
    health_status: string;
    slot_number: number | string;
  }
) {
  return api.update(`${baseUrl}/${id}`, payload);
}

// DELETE power bank
function deletePowerBankAPI(id: string) {
  return api.delete(`${baseUrl}/${id}`);
}

export { getAllPowerBanks, addPowerBankAPI, updatePowerBankAPI, deletePowerBankAPI };
